import {EventSource} from "./EventSource.js";

export class ChatUI extends EventSource {
	constructor() {
		super();
	}

	newMessageInChat(chatId, msg) {
	}

	typingStarted(chatId, data) {
	}

	typingEnded(chatId, data) {
	}

	debaterStateChanged(handle, state) {
	}

	/**
	 * Called when window visibility changes
	 * @param {boolean} vis indicates if the change was to "visible" (true)
	 */
	visible(vis) {
	}
}